import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Grid } from 'semantic-ui-react';
import axios from 'axios';


import ReactExport from 'react-data-export';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class StudyProgramPerCycle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            active: [],
            archived: [],
            excelDataActive: [],
            excelDataArchived: [],
            organizationalUnitId: null,

            orgUnitFilter: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),

        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        if (!this.state.orgUnitFilter) {
            axios.get('reports/study-program-basic-count/false/')
                .then(res => {
                    this.setState({
                        active: res.data,
                        excelDataActive: res.data.map(el => ([
                            { value: el.studyCycleName },
                            { value: el.numberOfStudyProgramBasics }
                        ]))
                    });
                });
            axios.get('reports/study-program-basic-count/true/')
                .then(res => {
                    this.setState({
                        archived: res.data,
                        excelDataArchived: res.data.map(el => ([
                            { value: el.studyCycleName },
                            { value: el.numberOfStudyProgramBasics }
                        ]))
                    });
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        axios.get(`reports/study-program-basic-count/for-admin/false/${value}/`)
            .then(res => {
                this.setState({
                    active: res.data,
                    excelDataActive: res.data.map(el => ([
                        { value: el.studyCycleName },
                        { value: el.numberOfStudyProgramBasics }
                    ]))
                });
            });
        axios.get(`reports/study-program-basic-count/for-admin/true/${value}/`)
            .then(res => {
                this.setState({
                    archived: res.data,
                    excelDataArchived: res.data.map(el => ([
                        { value: el.studyCycleName },
                        { value: el.numberOfStudyProgramBasics }
                    ]))
                });
            });
    }

    render() {
        const { report } = this.state;
        const multiDataSet = [
            {
                columns: [
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                    { title: 'Broj studijskih programa', width: { wpx: 200 } },

                ],
                data: this.state.excelDataActive,
            }
        ];

        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                    { title: 'Broj studijskih programa', width: { wpx: 200 } },

                ],
                data: this.state.excelDataArchived,
            }
        ];
        return (
            <div>
                {this.state.orgUnitFilter && <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <Form.Dropdown
                                clearable
                                label="Organizaciona jedinica"
                                placeholder="Organizaciona jedinica"
                                value={this.state.organizationalUnit}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                required
                                selection
                                error={this.state.organizationalUnitEntityError}
                            />
                        </Form.Field>
                        <Form.Field />
                    </Form.Group>
                </Form>}

                {((this.state.orgUnitFilter && this.state.organizationalUnitId) || !this.state.orgUnitFilter) && <div>
                    {this.state.active.length ? <Table celled selectable compact>

                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={9} >
                                    <Grid column={2} stackable>
                                        <Grid.Column width={14}>
                                            <h3>Aktivni studijski programi</h3>
                                            {/* <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['studyCycleName', 'numberOfStudyProgramBasics']} /> */}
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign="center">
                                            <ExcelFile
                                                filename="Broj aktivnih studijskih programa po ciklusu"
                                                element={<Popup
                                                    trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}
                                            >
                                                <ExcelSheet dataSet={multiDataSet} name="Studijski programi" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>Ciklus studija</Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}> Broj studijskih programa </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.active.map((el, index) =>
                            (<Table.Row key={el.id}>

                                <Table.Cell verticalAlign="middle" width="1"> {index + 1}. </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.studyCycleName} </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.numberOfStudyProgramBasics}</Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table> : 'Nema aktivnih studijskih programa.'
                    }
                    <br />

                    {this.state.archived.length ? <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={9} >
                                    <Grid column={2} stackable>
                                        <Grid.Column width={14}>
                                            <h3>Arhivirani studijski programi</h3>
                                            {/* <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['studyCycleName', 'numberOfStudyProgramBasics']} /> */}
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign="center">
                                            <ExcelFile
                                                filename="Broj arhiviranih studijskih programa po ciklusu"
                                                element={<Popup
                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}
                                            >
                                                <ExcelSheet dataSet={multiDataSet} name="Studijski programi" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>Ciklus studija</Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}> Broj studijskih programa </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.archived.map((el, index) =>
                            (<Table.Row key={el.id}>

                                <Table.Cell verticalAlign="middle" width="1"> {index + 1}. </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.studyCycleName} </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle" > {el.numberOfStudyProgramBasics}</Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table> : 'Nema arhiviranih studijskih programa.'}
                </div>}
            </div>
        );
    }
}

export default StudyProgramPerCycle;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudyProgramPerCycle.js